import { useState } from 'react';

const TestimonialsSection = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const testimonials = [
    [
      {
        name: 'Carlos Eduardo Silva',
        role: 'Cliente Residencial',
        text: 'Contratei os serviços da Desentupidora da Cidade Nº1 para resolver um entupimento no banheiro e fiquei impressionado com a rapidez do atendimento! A equipe chegou em menos de 30 minutos e resolveu o problema de forma definitiva. Profissionalismo exemplar!',
      },
      {
        name: 'Marina Santos Costa',
        role: 'Síndica de Condomínio',
        text: 'Tivemos uma emergência com entupimento na rede de esgoto do prédio durante o fim de semana, e a Desentupidora da Cidade Nº1 atendeu prontamente nossa solicitação. Trabalho impecável, equipe educada e preço muito justo. Super recomendo!',
      },
    ],
    [
      {
        name: 'Roberto Oliveira',
        role: 'Comerciante',
        text: 'Meu restaurante teve um problema sério de entupimento na cozinha, e a Desentupidora da Cidade Nº1 salvou meu negócio! Resolveram rapidamente sem interromper o funcionamento. Equipe especializada e muito competente.',
      },
      {
        name: 'Ana Paula Ferreira',
        role: 'Proprietária de Empresa',
        text: 'Contratei a Desentupidora da Cidade Nº1 para manutenção preventiva na minha empresa e fiquei surpreendida com a qualidade do serviço. Além do desentupimento, fizeram limpeza completa das tubulações. Trabalho excepcional e muito bem executado!',
      },
    ],
    [
      {
        name: 'Família Rodrigues',
        role: 'Cliente Residencial',
        text: 'Enfrentamos um entupimento grave na madrugada de sábado, e a Desentupidora da Cidade Nº1 nos atendeu imediatamente. O atendimento 24 horas é realmente diferencial, e a equipe resolveu tudo com muita agilidade. Excelente serviço!',
      },
      {
        name: 'Marcelo Henrique Lima',
        role: 'Gerente de Propriedade Comercial',
        text: 'Além da eficiência técnica impressionante, destaco o cuidado ambiental da Desentupidora da Cidade Nº1. Fiquei muito satisfeito ao saber que utilizam métodos sustentáveis em seus procedimentos, demonstrando responsabilidade social. Empresa de confiança total!',
      },
    ],
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % testimonials.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-800 mb-4">
            O que Nossos Clientes Dizem
          </h2>
          <p className="text-xl text-gray-600">
            Veja o que os clientes dizem sobre a Desentupidora da Cidade Nº1
          </p>
          <div className="w-24 h-1 bg-gradient-to-r from-blue-500 to-green-500 mx-auto mt-4"></div>
        </div>

        <div className="relative">
          <div className="overflow-hidden">
            <div
              className="flex transition-transform duration-500 ease-in-out"
              style={{ transform: `translateX(-${currentSlide * 100}%)` }}
            >
              {testimonials.map((slide, slideIndex) => (
                <div key={slideIndex} className="w-full flex-shrink-0">
                  <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                    {slide.map((testimonial, index) => (
                      <div key={index} className="bg-white rounded-lg shadow-lg p-8 relative">
                        <div className="absolute top-4 right-4 w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center">
                          <i className="ri-double-quotes-l text-blue-500 text-xl"></i>
                        </div>
                        <div className="mb-4">
                          <h4 className="font-bold text-gray-800 text-lg">{testimonial.name}</h4>
                          <p className="text-gray-600 text-sm">{testimonial.role}</p>
                        </div>
                        <div className="flex space-x-1 mb-4">
                          <i className="ri-star-fill text-yellow-400"></i>
                          <i className="ri-star-fill text-yellow-400"></i>
                          <i className="ri-star-fill text-yellow-400"></i>
                          <i className="ri-star-fill text-yellow-400"></i>
                          <i className="ri-star-fill text-yellow-400"></i>
                        </div>
                        <p className="text-gray-700 leading-relaxed italic">{testimonial.text}</p>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <button
            onClick={prevSlide}
            className="absolute left-0 top-1/2 transform -translate-y-1/2 -translate-x-4 w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-gray-50 transition-colors cursor-pointer"
          >
            <i className="ri-arrow-left-line text-gray-600 text-xl"></i>
          </button>

          <button
            onClick={nextSlide}
            className="absolute right-0 top-1/2 transform -translate-y-1/2 translate-x-4 w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-gray-50 transition-colors cursor-pointer"
          >
            <i className="ri-arrow-right-line text-gray-600 text-xl"></i>
          </button>

          <div className="flex justify-center mt-8 space-x-2">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentSlide(index)}
                className={`w-3 h-3 rounded-full transition-colors cursor-pointer ${
                  currentSlide === index ? 'bg-blue-500' : 'bg-gray-300'
                }`}
              ></button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;